import {
	GET_COMMENTS,
	GET_COMMENTS_SUCCESS,
	GET_COMMENTS_FAILURE,
	RESET_COMMENTS,
	ADD_COMMENT,
	ADD_COMMENT_SUCCESS,
} from './types';

export const getCommentsAction = (payload: any) => ({
	type: GET_COMMENTS,
	payload,
});

export const getCommentsSuccessAction = (payload: any) => ({
	type: GET_COMMENTS_SUCCESS,
	payload,
});

export const getCommentsFailureAction = (error: Error) => ({
	type: GET_COMMENTS_FAILURE,
	payload: error,
});

export const resetCommentsAction = () => ({
	type: RESET_COMMENTS,
});

export const addCommentAction = (payload: any) => ({
	type: ADD_COMMENT,
	payload,
});

export const addCommentSuccessAction = (payload: any) => ({
	type: ADD_COMMENT_SUCCESS,
	payload,
});
